import "./index.css";

import React, { Component } from "react";
import {
    Link,
} from "react-router-dom";

/* Components */
import Page from "../../../components/Page";
import NavigationBar from "../../../components/NavigationBar";
import WebFooter from "../../../components/WebFooter";

class ContactUs extends Component {

    componentDidMount() {
        document.title = "Contact Us - J4Crew Yacht Crew Recruitment";
        return window.scrollTo(0, 0);
    }

    render() {

        return(
            <Page match={this.props.match} hideNavbar={true}>
                <div className="page-intro-linear-container">
                    <NavigationBar { ...this.props } />
                    <div style={{ height: 30 }}></div>
                    <h4>Contact</h4>
                </div>
                <div style={{height: 75}}></div>
                <div className="about-us-team-header-container">
                    <p>Get in touch with us</p>
                </div>
                <div className="about-us-text">
                    <p style={{ textAlign: "center" }}>If you are <Link to={"/looking-for-crew"}>looking for crew</Link> please contact us using the details below, and we will get back to you right away. If you have any questions about our vacancies or roles, or would like to have an informal chat about your yachting career, please feel free to contact us.</p>
                    <div style={{ height: 30 }}></div>
                    <p style={{ textAlign: "center" }}>General Enquiries: <a href="mailto:crew@j4crew.com" target="_blank" rel="noopener noreferrer">crew@j4crew.com</a></p>
                    <div style={{ height: 30 }}></div>
                </div>
                <div style={{ height: 50 }}></div>
                <div className="about-us-team-member-container">
                    <div className="about-us-team-member-image-container">
                        <img src={require("../../../assets/images/jacob.webp")} alt="Jacob Hodgson" />
                    </div>
                    <div className="about-us-team-member-info-container">
                        <p className="about-us-team-member-name">Jacob Hodgson</p>
                        <p className="about-us-team-member-position">Director and Recruitment Consultant</p>
                        <div className="about-us-text">
                            <p>Email: <a href="mailto:jacob@j4crew.com" target="_blank" rel="noopener noreferrer">jacob@j4crew.com</a></p>
                            <p>Phone: <a href="https://wa.me/447598382232" target={"_blank"} rel="noopener noreferrer">+44 7598 382 232</a>. (WhatsApp)</p>
                        </div>                        
                        <div className="web-page-home-about-us-cell-row-socials-container">
                            <a href={"https://www.linkedin.com/in/jacob-hodgson-259b8b120/"} target={"_blank"} rel="noopener noreferrer">
                                <img src={require("../../../assets/svgs/linkedin.svg")} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ height: 50 }}></div>
                <WebFooter />
            </Page>
        );

    }

}

export default ContactUs;